export default __webpack_public_path__ + "static/media/aleksandar_m.097497de.jpg";